<!--
// app/components/Shared/icons/TwitchIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  profileLink?: string;
};

withDefaults(defineProps<Props>(), {
  width: 20,
});
</script>

<template>
  <component
    :is="profileLink ? 'a' : 'span'"
    :href.attr="profileLink"
    :target.attr="profileLink ? '_blank' : undefined"
  >
    <svg :width="width" :height="height" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.1326 6.06297L7.47982 7.72337H5.82704L4.38086 9.17621V7.72337H2.52148V1.49689H9.1326V6.06297Z"
        fill="transparent"
      />
      <path
        d="M2.10796 0.666687L0.0419922 2.74218V10.214H2.52116V12.2894L4.58713 10.214H6.23991L9.95866 6.47807V0.666687H2.10796ZM9.13227 6.06297L7.47949 7.72336H5.82671L4.38053 9.17621V7.72336H2.52116V1.49688H9.13227V6.06297Z"
        fill="currentColor"
      />
      <path d="M7.8928 2.94971H7.06641V5.4403H7.8928V2.94971Z" fill="currentColor" />
      <path d="M5.62033 2.94971H4.79395V5.4403H5.62033V2.94971Z" fill="currentColor" />
    </svg>
  </component>
</template>

<style scoped></style>
